import { Button, Input, Table, Tooltip } from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { UserInfo } from "../../../../context";

const DeliveryFullDetails = ({ close }) => {
  const { userData } = useContext(UserInfo);
  //   const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [merchantOrderSaveList, setMerchantOrderSaveList] = useState({
    data: [],
    ready: false,
  });
  const [total, setTotal] = useState(0);

  const tableLayout = "";
  const scroll = {};
  const tableProps = {
    bordered: false,
    // loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      // sorter: (a, b) => a.dr_date - b.dr_date,
      render: (date) => (
        <p>{moment(new Date(date), "YYYY-MM-DD").format("MMMM DD, YYYY")}</p>
      ),
      //    <p>{text}</p>
    },
    {
      title: "Product",
      dataIndex: ["deliverysaverawproduct", "product"],
      // sorter: (a, b) => a.dr_date - b.dr_date,
      render: (text) => <p>{text}</p>,
    },

    {
      title: "Expiry Date",
      dataIndex: "expiry_date",
      //   sorter: (a, b) => a.po_number - b.po_number,
      render: (text, record) => (
        <p
          style={
            {
              // textTransform: "uppercase",
              // fontWeight: "bold",
              // color: "blue",
            }
          }
          // onClick={() => console.log("record", record)}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Invoice Number",
      dataIndex: "invoice_number",
      //   sorter: (a, b) => a.po_number - b.po_number,
      render: (text, record) => (
        <p
          style={
            {
              // textTransform: "uppercase",
              // fontWeight: "bold",
              // color: "blue",
            }
          }
          // onClick={() => console.log("record", record)}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Qty * MSRP",
      // dataIndex: "quantity",
      //   sorter: (a, b) => a.po_number - b.po_number,
      align: "right",
      render: (text, record) => (
        <p
          style={
            {
              // textTransform: "uppercase",
              // fontWeight: "bold",
              // color: "blue",
            }
          }
          // onClick={() => console.log("record", record)}
        >
          {text.quantity} * {text.deliverysaverawproduct.msrp}
          {/* {console.log("TEXT", text)} */}
        </p>
      ),
    },
    {
      title: "Amount",
      // dataIndex: ["deliverysaverawproduct", "msrp"],
      align: "right",
      render: (text, record) => (
        <>
          {parseFloat(
            parseFloat(text.quantity) *
              parseFloat(text.deliverysaverawproduct.msrp)
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        parseFloat(data[i].deliverysaverawproduct.msrp) *
        parseFloat(data[i].quantity);
    }
    return total;
  };

  const getMerchantOrderSaveList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/get/fulldetails/save-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantOrderSaveList({ data, ready: true });
        setTotal(calculateTotal(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMerchantOrderSaveList();
  }, [getMerchantOrderSaveList]);

  const searchable = merchantOrderSaveList.data.filter((data) => {
    return (
      data.deliverysaverawproduct.product
        .toLowerCase()
        .indexOf(search.toLowerCase()) >= 0
    );
  });

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Tooltip title="Back">
            <Button
              type="primary"
              icon={<ArrowLeftOutlined />}
              //   style={{ marginLeft: 5 }}
              onClick={() => close()}
            >
              Back
            </Button>
          </Tooltip>
        </div>
        <div>
          <Input
            placeholder="Search product"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>
      </div>
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
          footer={() => (
            <div style={{ display: "flex" }}>
              <div style={{ flexGrow: 1 }} />
              Total:{" "}
              {total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          )}
        />
      </div>
    </>
  );
};

export default DeliveryFullDetails;
